import { useNavigate } from "react-router-dom";
import { ShieldAlert, X } from "lucide-react";
import { useImpersonation } from "@/providers/impersonation-provider";

export function ImpersonationBanner({ basePath = "/app" }: { basePath?: string }) {
  const { isImpersonating, targetTenantName, stopImpersonation } = useImpersonation();
  const navigate = useNavigate();

  if (!isImpersonating) return null;

  function handleExit() {
    stopImpersonation();
    navigate(`${basePath}/superadmin`);
  }

  return (
    <div className="flex items-center justify-between bg-red-600 px-4 py-2 text-sm font-medium text-white">
      <div className="flex items-center gap-2">
        <ShieldAlert className="h-4 w-4" />
        <span>
          Superadmin &mdash; viewing as <strong>{targetTenantName}</strong>
        </span>
      </div>
      <button
        onClick={handleExit}
        className="flex items-center gap-1 rounded px-2 py-1 text-xs hover:bg-red-700"
      >
        <X className="h-3 w-3" />
        Exit
      </button>
    </div>
  );
}
